import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
  token: string | null;
  refreshToken: string | null;
  user: any;
  isAuthenticated: boolean;
  loggingIn: boolean;
}

const session = JSON.parse(localStorage.getItem("session") || "null");

const initialState: AuthState = {
  token: session?.token || null,
  refreshToken: session?.refreshToken || null,
  user: session || null,
  isAuthenticated: !!session?.token,
  loggingIn: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoggingIn(state, action: PayloadAction<{ value: boolean }>) {
      state.loggingIn = action.payload.value;
    },
    setCredentials(
      state,
      action: PayloadAction<{ token: string; refreshToken: string }>,
    ) {
      localStorage.setItem("session", JSON.stringify(action.payload));
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = true;
      state.loggingIn = false;
    },
    setUser(state, action: PayloadAction<any>) {
      state.user = action.payload;
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = true;
    },
    logout(state) {
      state.token = null;
      state.refreshToken = null;
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem("session");
    },
  },
});

export const { setCredentials, setUser, logout, setLoggingIn } =
  authSlice.actions;
export default authSlice.reducer;
